// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Album__icon-a4a291 {
  fill: var(--base-80);
  margin-inline-end: 4px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/SearchMessages/Message/Payload/Album/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,sBAAA;EACA,sBAAA;AACF","sourcesContent":[".icon {\n  fill: var(--base-80);\n  margin-inline-end: 4px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Album__icon-a4a291`
};
module.exports = ___CSS_LOADER_EXPORT___;
